<ion-content [fullscreen]="true">
  <div class="wrapper-form">
    <div class="logo-container">
      <img class="intersport-logo" src="../assets/icon/intersport-logo.webp">
      <img class="logo" src="../assets/icon/bg.jpg" />
    </div>
    <div class="title-container">
      <div class="title">
        <h3>
          ΕΓΓΡΑΦΗ ΜΕΛΟΥΣ
        </h3>
      </div>
      <div class="subtitle">
        <img src="../assets/icon/favicon.png" alt="intersport_logo">
        <h6>
          INTERSPORT Club: Γίνε κι εσύ μέλος του μεγαλύτερου club προνομίων!
        </h6>
      </div>
    </div>
    <div *ngIf="!otpValidationFacadeService.showRegistrationForm">
      <div class="otp">
        <ion-qc-otp-validation
          [otpValidationConfig]="otpValidationConfig"
        ></ion-qc-otp-validation>
      </div>
    </div>
    <div *ngIf="otpValidationFacadeService.showRegistrationForm">
      <ion-qc-person-details-form [personDetails]="personDetails" />
      <ion-button
        [disabled]="personDetailsFacadeService.submitButtonDisabled$ | async"
        (click)="register()"
        >ΕΓΓΡΑΦΗ</ion-button
      >
    </div>

    <div *ngIf="personDetailsFacadeService.submitted">
      <ion-label
        *ngIf="personDetailsFacadeService.isDataCreated"
        class="align-text"
      >
        Η εγγραφή σου ολοκληρώθηκε🙂Ευχαριστούμε!
      </ion-label>
      <ion-label
        *ngIf="!personDetailsFacadeService.isDataCreated"
        class="align-text"
      >
        Η εγγραφή σου δεν ολοκληρώθηκε😞Δοκίμασε ξανά!
      </ion-label>
    </div>
  </div>
</ion-content>
